// global css imports
import "flexboxgrid";
import "./scss/index.scss";

import { polyfill } from "seamless-scroll-polyfill";

import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import NProgress from "nprogress";

import App from "./js/containers/App";
import store, { history } from "./js/store";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import DataFetcher from "./js/utils/DataFetcher";
import Routes from "./js/Routes";
import actions from "./js/actions/index.js";
// import GAEvents from "@utils/GoogleAnalytics";
import scrollToAnchor from "./js/utils/scrollToAnchor";

if (
    process.env.NODE_ENV === "development" &&
    process.env.REACT_APP_MOCK_SERVICE_WORKER_ENABLED === "true"
) {
    const { worker } = require("./mocks/browser");
    worker.start();
}

// POLYFILLS
polyfill();

// set "using-mouse" class for styling focus states for keyboard only
if (document.body) {
    document.body.addEventListener("mousedown", function () {
        if (document.body) {
            document.body.classList.remove("using-keys");
            document.body.classList.add("using-mouse");
        }
    });
    document.body.addEventListener("touchstart", function () {
        if (document.body) {
            document.body.classList.remove("using-keys");
            document.body.classList.add("using-mouse");
        }
    });
    document.body.addEventListener("keydown", function () {
        if (document.body) {
            document.body.classList.remove("using-mouse");
            document.body.classList.add("using-keys");
        }
    });
}

// Configure the site laoding bar
NProgress.configure({
    minimum: 0.3,
    trickleSpeed: 250,
    easing: "ease",
    speed: 250,
    showSpinner: false,
});

const OuterApp = () => {
    const handleLoadingStateChange = ({ loading, error }: any = {}) => {
        if (loading) {
            NProgress.start();
        } else {
            NProgress.done();

            window.scrollTo({
                top: 0,
                left: 0,
                // behavior: "smooth",
            });

            if (window.location.hash.substr(1)) {
                setTimeout(() => {
                    scrollToAnchor(window.location.hash.substr(1));
                }, 2000);
            }
        }
        if (error) {
            NProgress.done();
        }
    };
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <DataFetcher
                    routes={Routes}
                    passToPreload={{ store }}
                    onLoadingStateChange={handleLoadingStateChange}
                    initialPreload={(): Promise<any> => {
                        return Promise.all([
                            store.dispatch(actions.initialFetchAll()),
                        ]);
                    }}
                >
                    <App />
                </DataFetcher>
            </ConnectedRouter>
        </Provider>
    );
};

const rootEl = document.getElementById("root");
if (rootEl) {
    ReactDOM.render(<OuterApp />, rootEl);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
if (
    process.env.NODE_ENV !== "development" ||
    process.env.REACT_APP_MOCK_SERVICE_WORKER_ENABLED !== "true"
) {
    serviceWorker.unregister();
}
